import { createAction } from '@reduxjs/toolkit';
import { MOBILE_NAV_BAR_ACTION_TYPES } from '../constants/actionTypes/mobileNavBar';

export const setMobileNavIsOpen = createAction<{ isOpen: boolean}>(
  MOBILE_NAV_BAR_ACTION_TYPES.SET_MOBILE_NAV_IS_OPEN,
);

export const setMobileSearchbarOpen = createAction<{isOpen: boolean}>(
  MOBILE_NAV_BAR_ACTION_TYPES.SET_MOBILE_SEARCHBAR_OPEN,
);
